import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/sections/ecosystem/map.jpg")